<template>
<div class="content">
  <div v-if="success" class="pop-up">
    <div class="message">
      已提交申請。
      <div class="btn btn-primary rounded-0 py-3 px-4
      h-auto d-block mt-2" @click="success = false">
        確定
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="row justify-content-center">
        <div class="col-md-12">
          <h4>刪除《壹蘋新聞網》帳戶和相關資料</h4>
          <p>
            <ul><li>欲移除開放平台資料可於《壹蘋新聞網》APP 登入後在會員頁面中點選“移除帳號” </li><li>或，填寫以下表格申請</li></ul>
          </p>
        </div>
        <div class="col-md-12">
          <form
            class="mb-5"
            method="post"
            id="contactForm"
            name="contactForm"
            @submit.prevent="submitForm"
            ref="form"
          >
          <div class="row">
            <div class="col-md-12 form-group">
              <input
                v-model="form.email"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': !validEmail }"
                name="email"
                id="email"
                placeholder="帳戶E-mail信箱 *"
              />
              <div class="invalid-feedback">
                請輸入正確的 E-mail 信箱
              </div>
            </div>
          </div>
          <div class="row">
              <div class="col-md-12 form-group">
                <input
                  v-model="form.name"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': !validName }"
                  name="name"
                  id="name"
                  placeholder="姓名 *"
                />
                <div class="invalid-feedback">
                  請輸入 姓名
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 form-group">
                <textarea
                  v-model="form.reason"
                  class="form-control"
                  name="description"
                  id="description"
                  :style="{height: '180px'}"
                  :class="{ 'is-invalid': !validDesc }"
                  placeholder="原因"
                ></textarea>
                <div class="invalid-feedback">
                  請輸入 原因
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">* 必填</div>
            </div>
            <div class="row">
              <div class="col-12">
                <ChallengeV3 v-model="response" action="submit"
                  v-slot="slotProps" :autoExecute="false">
                  <div
                    :disabled="!canSubmit"
                    @click="submitForm(slotProps)"
                    class="btn btn-primary rounded-0 py-3 px-4 h-auto">
                    {{ submitBtnText }}
                  </div>
                </ChallengeV3>

                <span class="submitting"></span>
              </div>
            </div>
          </form>

          <!-- <div id="form-message-warning mt-4"></div> -->
          <div id="form-message-success" v-if="success">謝謝您</div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios';
import { ChallengeV3 } from 'vue-recaptcha';

export default {
  components: {
    ChallengeV3
  },
  data() {
    return {
      titleMaxLength: 15,
      message: "Ready",
      files: [],
      success: false,
      submitted: false,
      shouldCheck: false,
      credential: null,
      form: {
        title: "",
        name: "",
        tel: "",
        email: "",
        reason: "",
        location: "",
        files: [],
      },
      submitting: false,
    };
  },
   mounted() {
    //   google.accounts.id.initialize({
    //   client_id: '852836185297-n0nap0s10s17927937ofbuag5009234n.apps.googleusercontent.com',
    //   callback: function(resp) {
    //     this.credential = resp.credential;
    //   }
    // });

    //   const parent = document.getElementById('google_btn');
    //   google.accounts.id.renderButton(this.$refs.loginBtn, { 
    //     theme: "outline",
    //     width: 400,
    //     logo_alignment: 'center',
    //   });
    //   google.accounts.id.prompt(function(noti) {
        
    //   });
    },
  computed: {
    submitBtnText() {
      if (this.uploading) {
        return '請等待上傳完成';
      }

      if (this.submitting) {
        return '提交中...';
      }

      return '提交';
    },
    uploading() {
      let ready = true;

      for (var i = 0; i < this.files.length; i++) {
        ready = ready && this.files[i].ready;
      }

      return !ready;
    },
    canSubmit() {
      return !this.uploading && !this.submitting;
    },
    titleTooLong() {
      return this.form.title.length > this.titleMaxLength;
    },
    isValid() {
      let valid = true;

      valid = valid && this.validEmail;
      valid = valid && this.validEmail;

      return valid;
    },
    validTitle() {
      return !this.shouldCheck || (this.form.title.length && !this.titleTooLong);
    },
    validName() {
      return !this.shouldCheck || this.form.name.length;
    },
    validDesc() {
      return true;
    },
    validEmail() {
      if (!this.shouldCheck && !this.form.email) {
        return true;
      }

      return /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i.test(this.form.email);
    },
    validTel() {
      if (!this.form.tel) {
        return true;
      }

      return /09\d{2}\-?\d{3}\-?\d{3}/.test(this.form.tel);
    }
  },
  methods: {
    async submitForm(recaptcha) {
      this.shouldCheck = true;

      if (!this.isValid) {
        return;
      }

      this.submitting = true;
      this.submitted = true;

      const captchaResp = await recaptcha.execute();
      this.form.recaptcha = captchaResp;

      axios
        .post("/api/data-safety", this.form)
        .then(() => {
          this.submitting = false;
          this.success = true;
          this.shouldCheck = false;
          this.form = {
            email: '',
            reason: '',
            name: '',
          };
        })
        .catch(() => {
          this.submitting = false;
          this.submitted = false;
        });
    },
    uploadFiles(e) {
      const files = e.target.files;

      if (files) {
        var filesAmount = files.length;

        for (let i = 0; i < filesAmount; i++) {
          var reader = new FileReader();

          reader.onload = (event) => {
            const dataUrl = event.target.result;
            const ext = "." + files[i].name.split(".").pop();

            axios
              .get("/api/upload/pre-sign", { params: { ext } })
              .then((resp) => {
                const url = resp.data.url;
                const key = resp.data.key;
                var formData = new FormData();
                const isImage = dataUrl && dataUrl.startsWith("data:image");
                formData.append("file", files[i]);

                const result = {
                  preview: isImage ? dataUrl : "",
                  isImage: isImage,
                  key: key,
                  progress: 0,
                  ready: false,
                  name: files[i].name,
                };

                this.files.push(result);
                return axios
                  .put(url, files[i], {
                    headers: {
                      "Content-Type": files[i].type,
                    },
                    onUploadProgress: (progressEvent) => {
                      const progress = parseInt(
                        Math.round(
                          (progressEvent.loaded / progressEvent.total) * 100
                        )
                      );
                      const staging = this.files;
                      for (var j = 0; j < staging.length; j++) {
                        if (staging[j].key === key) {
                          staging[j].progress = progress;
                        }
                      }
                    },
                  })
                  .then(() => {
                    const staging = this.files;
                    for (var j = 0; j < staging.length; j++) {
                      if (staging[j].key === key) {
                        staging[j].ready = true;
                      }
                    }
                  });
              });
          };

          reader.readAsDataURL(files[i]);
        }
      }
    },
  },
};
</script>
